import { useEffect, useRef } from "preact/hooks";
import { playUiCue } from "../audio";

/**
 * A sheet, viewer or overlay that is not a route: the open cue when it appears, the close cue when it
 * goes. A layer with a stepped exit (src/components/useExit.ts) passes `closing`, so the falling cue
 * lands with the press that starts the exit rather than with the unmount after it.
 */
export function useScreenCue(closing = false): void {
  const played = useRef(false);
  useEffect(() => {
    void playUiCue("open");
    return () => {
      if (!played.current) void playUiCue("close");
    };
  }, []);
  useEffect(() => {
    if (!closing || played.current) return;
    played.current = true;
    void playUiCue("close");
  }, [closing]);
}

/** The same, as an element, for overlays rendered inside a condition rather than as their own component. */
export function ScreenCue({ closing = false }: { closing?: boolean }) {
  useScreenCue(closing);
  return null;
}
